import React from 'react';
import { __ } from '@wordpress/i18n'; 

const getIllustrationUrl = () => {
    if (typeof window.thhaAdminSettings !== 'undefined' && window.thhaAdminSettings.assets_url) {
        return window.thhaAdminSettings.assets_url + 'img/support-banner.svg';
    }
    return 'none'; // Fallback
};

const AskForSupport = () => {
  return (
    <div className='feature-request-container'>
      <div className='feature-request-content' style={{ backgroundImage: `url(${getIllustrationUrl()})`, backgroundPosition: "right bottom", backgroundRepeat: "no-repeat", marginRight: "20px" }}>
        
        <div className="subheading"><span className="thha-icon thha-icon-support " ></span>{__('Support', 'huge-addons-for-elementor')}</div>
        <h2 className='feature-request-title'>{__('Quick Access', 'huge-addons-for-elementor')}</h2>
        <p className='feature-request-description'>
          {__('We designed huge addons to be intuitive but we do recommend learning how it works by checking our ', 'huge-addons-for-elementor')}
        </p>
        <div className="support-features-list">
          <ul>
            <li><span className="thha-icon thha-icon-call-center"></span>{__('VIP Support', 'huge-addons-for-elementor')} <span className="pro-badge">pro</span></li>
            <li><span className="thha-icon thha-icon-help-center"></span>{__('Help Center', 'huge-addons-for-elementor')}</li>
            <li><span className="thha-icon thha-icon-bubble-chat"></span>{__('Join The Community', 'huge-addons-for-elementor')}</li>
            <li><span className="thha-icon thha-icon-star"></span>{__('Rate Us', 'huge-addons-for-elementor')}</li>
            
          </ul>
        </div>
      </div>
      
      {/* <div 
        className='feature-request-image'
        
      >
      </div> */}
    </div>
  );
};

export default AskForSupport;